import React from 'react'

import withDefaultStyles from '../../Icons/withDefaultStyles'

const Check = () => (
  <svg viewBox="0 0 10 8" xmlns="http://www.w3.org/2000/svg">
    <path d="M8.93332 0.443839C8.78332 0.333839 8.60332 0.273839 8.42332 0.303839C8.24332 0.323839 8.07332 0.413839 7.96332 0.563839L3.44332 6.28384L2.06332 4.32384C1.95332 4.17384 1.80332 4.07384 1.61332 4.04384C1.43332 4.01384 1.25332 4.04384 1.10332 4.16384C0.95332 4.27384 0.85332 4.42384 0.82332 4.60384C0.79332 4.78384 0.823321 4.96384 0.94332 5.11384L2.36332 7.13384C2.47332 7.30384 2.63332 7.44384 2.81332 7.54384C2.99332 7.64384 3.19332 7.69384 3.40332 7.70384H3.44332C3.63332 7.70384 3.83332 7.66384 4.00332 7.57384C4.19332 7.48384 4.35332 7.35384 4.47332 7.19384L9.04332 1.40384C9.15332 1.26384 9.20332 1.08384 9.18332 0.893839C9.16332 0.713839 9.07332 0.543839 8.92332 0.433839L8.93332 0.443839Z" />
  </svg>
)

export default withDefaultStyles(Check)
